// GENERATED during the Netlify build by scripts/sync-reviews.mjs. See the
// committed copy for what this file is; do not commit this one.
export const reviewsSnapshot = {
  "builtAt": "2026-11-04T10:02:40.171Z",
  "properties": {
    "saltgrass-cottage": {
      "status": "held",
      "reason": "OwnerRez returned no rated guest reviews",
      "ownerRez": {
        "count": 0,
        "rating": null,
        "checkedAt": "2026-11-04T10:02:39.961Z"
      }
    }
  }
};
